import type { ButtonHTMLAttributes, ReactNode } from 'react'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'success'
type Size = 'sm' | 'md' | 'lg'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
  children?: ReactNode
}

const VARIANT: Record<Variant, string> = {
  primary: 'bg-[var(--color-accent)] hover:bg-[var(--color-accent-hover)] text-white border-transparent',
  secondary: 'bg-[var(--color-elevated)] hover:bg-[var(--color-border)] text-[var(--color-text)] border-[var(--color-border)]',
  ghost: 'bg-transparent hover:bg-[var(--color-elevated)] text-[var(--color-text-muted)] hover:text-[var(--color-text)] border-transparent',
  danger: 'bg-[var(--color-danger)]/10 hover:bg-[var(--color-danger)]/20 text-[var(--color-danger)] border-[var(--color-danger)]/30',
  success: 'bg-[var(--color-success)]/10 hover:bg-[var(--color-success)]/20 text-[var(--color-success)] border-[var(--color-success)]/30',
}

const SIZE: Record<Size, string> = {
  sm: 'h-7 px-2.5 text-xs gap-1.5',
  md: 'h-8 px-3 text-sm gap-2',
  lg: 'h-10 px-4 text-sm gap-2',
}

export default function Button({
  variant = 'secondary',
  size = 'md',
  className = '',
  children,
  ...rest
}: Props) {
  return (
    <button
      className={[
        'inline-flex items-center justify-center rounded-md border font-medium',
        'disabled:opacity-50 disabled:pointer-events-none',
        'active:scale-[0.98]',
        VARIANT[variant],
        SIZE[size],
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </button>
  )
}
